import PropTypes from 'prop-types'
import { Route } from "react-router-dom";
import UserService from "../services/UserService";
import NotAllowed from "./NotAllowed";

type Props = {
  roles: any,
  children:any
};
const RolesRoute =({ roles, children }: Props) => {
  
    return UserService.hasRole(roles) ? children : <NotAllowed/>
}

RolesRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default RolesRoute
